import { useEffect, useState, useRef } from 'react'

const MIN_VISIBLE_COLUMNS_DEFAULT = 4

export const getStoredOrDefaultVisibility = (getStored, defaultVisibility) => {
  const stored = getStored && getStored()

  return stored ? { ...defaultVisibility, ...stored } : { ...defaultVisibility }
}

export const useReportColumnSettings = (options = {}) => {
  const { getStored, setStored, defaultVisibility, minVisibleColumns = MIN_VISIBLE_COLUMNS_DEFAULT } = options

  const messagesRef = useRef(null)

  const [isSettingsOpen, setIsSettingsOpen] = useState(false)
  const [activeCheckBox, setActiveCheckBox] = useState(() => getStoredOrDefaultVisibility(getStored, defaultVisibility))
  const [disableSubmit, setDisableSubmit] = useState(false)

  const visibleColumnsMap = getStored && setStored ? getStored() || activeCheckBox : activeCheckBox

  const updateDisableSubmit = (visibility) => {
    const count = Object.keys(visibility).filter((k) => visibility[k]).length

    setDisableSubmit(count < minVisibleColumns)
  }

  const handleCheckboxChange = (column, e) => {
    const updated = { ...activeCheckBox, [column.dataField]: e.checked }

    setActiveCheckBox(updated)
    updateDisableSubmit(updated)
  }

  const handleSettingsSubmit = () => {
    setIsSettingsOpen(false)
    if (setStored) setStored(activeCheckBox)
  }

  const handleSettingsClose = () => {
    setIsSettingsOpen(false)
    if (getStored) setActiveCheckBox(getStoredOrDefaultVisibility(getStored, defaultVisibility))
  }

  const openSettings = () => setIsSettingsOpen(true)
  const closeSettings = () => handleSettingsClose()

  useEffect(() => {
    if (!isSettingsOpen) return
    updateDisableSubmit(activeCheckBox)
  }, [activeCheckBox, isSettingsOpen])

  const initStorageIfEmpty = () => {
    if (getStored && setStored && !getStored()) {
      setStored(defaultVisibility)
    }
  }

  return {
    visibleColumnsMap,
    activeCheckBox,
    setActiveCheckBox,
    isSettingsOpen,
    openSettings,
    closeSettings,
    handleCheckboxChange,
    handleSettingsSubmit,
    handleSettingsClose,
    disableSubmit,
    messagesRef,
    initStorageIfEmpty
  }
}
